
// general style

import "./src/styles/_index.scss";